import "react-phone-number-input/style.css";
import de from "react-phone-number-input/locale/de";
import { FormGroup, Form, InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import ValidationMessage from "../ValidationMessage";

const PhoneInputField = ({ field }) => {
  // A country picker with a single option does nothing; it is hidden via CSS
  // so the number field gets the room (long placeholders got cut on phones)
  const isSingleCountry = field.countries.length === 1;
  return (
    <FormGroup controlId={field.name} className="mb-4">
      <Form.Label className={field.hasError && "text-danger"}>
        {field.title}:{field.hasError && "*"}
      </Form.Label>
      <InputGroup className={isSingleCountry ? "single-country-phone" : ""}>
        <InputGroup.Text className={field.hasError && "bg-danger text-white"}>
          <FontAwesomeIcon icon={field.icon} />
        </InputGroup.Text>
        <PhoneInputWithCountry
          // `id` links the label above to the input
          id={field.name}
          enterKeyHint="send"
          addInternationalOption={false}
          defaultCountry={field.countries[0]}
          countries={field.countries}
          name={field.name}
          placeholder={field.placeholder}
          // for translation of country names in German
          labels={de}
        />
      </InputGroup>
      <ValidationMessage message={field.hasError?.message} />
    </FormGroup>
  );
};

export default PhoneInputField;
